export const ADMIN_SESSION_EXPIRED_EVENT = 'admin-session-expired';

export interface AdminSessionExpiredDetail {
  source?: string;
}

export function dispatchAdminSessionExpired(detail?: AdminSessionExpiredDetail): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<AdminSessionExpiredDetail>(ADMIN_SESSION_EXPIRED_EVENT, {
      detail,
    }),
  );
}
